export function browserSupportsWebGL() {
  var canvas = document.createElement('canvas');
  var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

  //This is for tracking purpose
  if (gl === null || !(gl instanceof WebGLRenderingContext)) {
    console.error('webGL is not supported');
    window.Rollbar.error('Error: webGL is not supported');
  }
  return gl !== null && gl instanceof WebGLRenderingContext;
}
